const moment = require("moment");

function copyTime(target, source) {
	return target.hour(source.hour()).minute(source.minute()).second(source.second()).millisecond(source.millisecond());
}

function toSameDayOfWeek(source, reference) {
	return copyTime(source.clone().startOf("isoWeek").add(
		reference.diff(reference.clone().startOf("isoWeek"), "day"),
		"day"
	), source);
}

function toSameWeek(source, reference) {
	return copyTime(reference.clone().startOf("isoWeek").add(
		source.diff(source.clone().startOf("isoWeek"), "day"),
		"day"
	), source);
}

function intervalsOverlap(lowerBound1, upperBound1, lowerBound2, upperBound2) {
	return (
		(upperBound1.isAfter(lowerBound2) && lowerBound1.isBefore(upperBound2)) ||
		(upperBound2.isAfter(lowerBound1) && lowerBound2.isBefore(upperBound1)) ||
		(lowerBound1.isSame(lowerBound2) && upperBound1.isSame(upperBound2))
	);
}

function inInterval(needle, lowerBound, upperBound, inclusive = true) {
	if (lowerBound && (inclusive ? lowerBound.isAfter(needle) : lowerBound.isSameOrAfter(needle))) {
		return false;
	}

	if (upperBound && (inclusive ? upperBound.isBefore(needle) : upperBound.isSameOrBefore(needle))) {
		return false;
	}

	return true;
}

function onSameDay(...args) {
	let dayReference;
	let date;

	for (let i = 0; i < args.length; i++) {
		date = args[i];

		if (dayReference == null) {
			dayReference = date.format("YYYY-MM-DD");
			continue;
		}

		if (dayReference !== date.format("YYYY-MM-DD")) {
			return false;
		}
	}

	return true;
}

function normalizeDate(date) {
	return date.clone().millisecond(0);
}

function sameMoments(...args) {
	let ref;

	for (let i = 0; i < args.length; i++) {
		if (ref == null) {
			ref = normalizeDate(args[i]);
			continue;
		}

		if (!ref.isSame(normalizeDate(args[i]))) {
			return false;
		}
	}

	return true;
}

module.exports = {
	toSameDayOfWeek,
	copyTime,
	intervalsOverlap,
	inInterval,
	toSameWeek,
	onSameDay,
	normalizeDate,
	sameMoments
};


// WEBPACK FOOTER //
// ./resources/js/helpers/moment.js